var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TypeTag",style:({backgroundColor: _vm.bgColor})},[_vm._t("slot-text")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }